import React from "react";

export default function Footer() {
    return (
        <footer className="site-footer" role="contentinfo">
            <div className="container">
                <div className="brand">
                    <img className="footerImg" src={require("../assets/img/swiftex1.png")} />
                </div>
                <address className="contact">
                    <div>Contact Us</div>
                    <a href="mailto:hello@myapp.example">bitrader@info.com</a>
                    <div className="small">123 Example St, City</div>
                </address>

                <div className="newsletter">
                    <div className="nl-title">Join Our Members</div>
                    <form
                        onSubmit={(e) => {
                            e.preventDefault();
                            // handle subscribe
                        }}
                    >
                        <label className="visually-hidden" htmlFor="ft-email">
                            Email
                        </label>
                        <input
                            id="ft-email"
                            type="email"
                            inputMode="email"
                            placeholder="Your email"
                            required
                        />
                        <button type="submit">Join</button>
                    </form>
                </div>
            </div>

            <div className="bottom">
                <div>© {new Date().getFullYear()} SwiftEx. All rights reserved.</div>
                <div className="policy-links">
                    <a href="#terms">Terms</a>
                    <a href="#privacy">Privacy</a>
                </div>
            </div>

            <style>{`
                /* Reset box-sizing scoped to footer to help avoid overflow */
                .site-footer, .site-footer * { box-sizing: border-box; }

                .site-footer {
                    background: #1A2028;
                    color: #fff;
                    width: 100%;
                    overflow-x: hidden;
                    padding: 2rem 1rem;
                    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
                }

                .container {
                    max-width: 1100px;
                    margin: 0 auto;
                    display: flex;
                    gap: 1.5rem;
                    align-items: flex-start;
                    justify-content: space-between;
                    flex-wrap: wrap;
                }
                .footerImg {
                    width: 18vw;
                    position: absolute;
                    left: 7%;
                    margin-top: 5%;
                    }
                    
                .brand {
                    display: flex;
                    gap: 0.75rem;
                    align-items: center;
                    min-width: 180px;
                    flex: 1 1 220px;
                }

                .logo-dot {
                    width: 42px;
                    height: 42px;
                    border-radius: 8px;
                    background: linear-gradient(180deg, #16a34a 0%, #12a24a 100%);
                    box-shadow: 0 2px 8px rgba(22,163,74,0.12);
                    flex: 0 0 42px;
                }

                .brand-title {
                    font-weight: 700;
                    font-size: 1.05rem;
                    letter-spacing: 0.2px;
                }

                .brand-sub {
                    font-size: 0.78rem;
                    color: rgba(255,255,255,0.75);
                }

                .links {
                    display: flex;
                    gap: 1rem;
                    flex: 1 1 220px;
                    flex-wrap: wrap;
                    align-items: flex-start;
                }

                .links a {
                    color: rgba(255,255,255,0.92);
                    text-decoration: none;
                    font-size: 0.95rem;
                    padding: 0.125rem 0;
                }

                .links a:hover,
                .links a:focus {
                    color: #16a34a;
                    outline: none;
                }

                .contact {
                    color: rgba(255,255,255,0.92);
                    font-style: normal;
                    display: flex;
                    flex-direction: column;
                    gap: 0.35rem;
                    flex: 1 1 220px;
                }

                .contact a {
                    color: rgba(255,255,255,0.95);
                    text-decoration: none;
                }

                .contact .small {
                    color: rgba(255,255,255,0.65);
                    font-size: 0.85rem;
                }

                .newsletter {
                    flex: 1 1 260px;
                    min-width: 200px;
                }

                .nl-title {
                    font-weight: 600;
                    margin-bottom: 0.5rem;
                }

                .newsletter form {
                    display: flex;
                    gap: 0.5rem;
                    align-items: center;
                    width: 100%;
                }

                .newsletter input {
                    flex: 1 1 auto;
                    padding: 0.6rem 0.75rem;
                    border-radius: 8px;
                    border: 1px solid rgba(255,255,255,0.08);
                    background: rgba(255,255,255,0.03);
                    color: #fff;
                    min-width: 0;
                }

                .newsletter input::placeholder {
                    color: rgba(255,255,255,0.5);
                }

                .newsletter button {
                    background: #16a34a;
                    color: #07210f;
                    border: none;
                    padding: 0.6rem 0.9rem;
                    border-radius: 8px;
                    cursor: pointer;
                    font-weight: 600;
                }

                .newsletter button:hover,
                .newsletter button:focus {
                    filter: brightness(0.95);
                    outline: none;
                }

                .bottom {
                    max-width: 1100px;
                    margin: 1.5rem auto 0;
                    padding-top: 1rem;
                    border-top: 1px solid rgba(255,255,255,0.04);
                    display: flex;
                    gap: 1rem;
                    justify-content: space-between;
                    align-items: center;
                    color: rgba(255,255,255,0.75);
                    font-size: 0.9rem;
                    flex-wrap: wrap;
                }

                .policy-links {
                    display: flex;
                    gap: 1rem;
                }

                .policy-links a {
                    color: rgba(255,255,255,0.85);
                    text-decoration: none;
                }

                .policy-links a:hover,
                .policy-links a:focus {
                    color: #16a34a;
                }

                /* Accessibility helper (visually hidden) */
                .visually-hidden {
                    position: absolute !important;
                    height: 1px; width: 1px;
                    overflow: hidden;
                    clip: rect(1px, 1px, 1px, 1px);
                    white-space: nowrap;
                }

                /* Responsive tweaks */
                @media (max-width: 720px) {
                    .container {
                        gap: 1rem;
                    }
                    .brand, .links, .contact, .newsletter {
                        flex: 1 1 100%;
                        min-width: 0;
                    }
                    .links {
                        gap: 0.5rem;
                    }
                    .newsletter form {
                        flex-direction: column;
                        align-items: stretch;
                    }
                    .newsletter button {
                        width: 100%;
                    }
                    .bottom {
                        gap: 0.5rem;
                        flex-direction: column;
                        align-items: stretch;
                    }
                }

                /* Prevent accidental horizontal overflow from long words/links */
                .site-footer a { overflow-wrap: anywhere; word-break: break-word; }
            `}</style>
        </footer>
    );
}